import React from "react";

import {
    Document,
    Page,
    Text,
    View,
    StyleSheet
} from "@react-pdf/renderer";



const BLACK = "#111827";
const ORANGE = "#d35400";
const LIGHT_GRAY = "#f3f4f6";
const GRAY = "#6b7280";
const CAMEL = "#b08968";
const WHITE = "#ffffff";



const styles = StyleSheet.create({

    page: {

        size: "A4",

        orientation: "landscape",

        padding: 28,

        backgroundColor: LIGHT_GRAY,

        fontFamily: "Helvetica"

    },


    header: {

        backgroundColor: "#bebec3",

        padding: 18,

        borderRadius: 8,

        marginBottom: 15

    },


    headerTitle: {

        color: BLACK,

        fontSize: 20,

        fontWeight: "bold",

        textAlign: "center"

    },


    headerSub: {

        color: "#18202c",

        fontSize: 10,

        marginTop: 6,

        textAlign: "center"

    },



    summaryContainer: {

        flexDirection:"row",

        gap:10,

        marginBottom:15

    },


    summaryBox: {

        flex:1,

        backgroundColor:WHITE,

        padding:12,

        borderRadius:6,

        borderLeftWidth:5,

        borderLeftColor:ORANGE

    },


    summaryLabel: {

        fontSize:9,

        color:GRAY

    },


    summaryValue: {

        marginTop:5,

        fontSize:16,

        fontWeight:"bold",

        color:BLACK

    },



    studentCard: {


        backgroundColor:WHITE,

        borderRadius:8,

        marginBottom:14,

        padding:12,

        borderWidth:1,

        borderColor:"#d1d5db"


    },


    studentHeader:{


        flexDirection:"row",

        justifyContent:"space-between",

        alignItems:"center",

        backgroundColor:"#fafafa",

        padding:8,

        borderBottomWidth:1,

        borderBottomColor:"#e5e7eb",

        marginBottom:8


    },


    studentName:{

        fontSize:13,

        fontWeight:"bold",

        color:BLACK

    },


    countBadge:{


        backgroundColor:ORANGE,

        color:WHITE,

        padding:5,

        borderRadius:4,

        fontSize:9


    },



    complaintBox:{


        marginTop:8,

        padding:9,

        backgroundColor:"#f9fafb",

        borderLeftWidth:4,

        borderLeftColor:CAMEL,

        borderRadius:5


    },


    complaintTitle:{


        fontSize:11,

        fontWeight:"bold",

        color:BLACK


    },


    complaintText:{


        fontSize:9,

        color:"#374151",

        marginTop:4,

        lineHeight:1.4


    },


    complaintMeta:{


        fontSize:8,

        color:GRAY,

        marginTop:5


    },


    footer:{


        marginTop:15,

        borderTopWidth:1,

        borderTopColor:"#d1d5db",

        paddingTop:8


    },


    footerText:{


        fontSize:8,

        color:GRAY,

        textAlign:"center"


    }



});





const StudentComplainChartPDF = ({
    data
}) => {


return (

<Document>


<Page
    size="A4"
    orientation="landscape"
    style={styles.page}
>


<View style={styles.header}>


<Text style={styles.headerTitle}>

Student Complaint Report

</Text>


<Text style={styles.headerSub}>

Academic Complaint Monitoring System

</Text>


</View>





<View style={styles.summaryContainer}>


<View style={styles.summaryBox}>

<Text style={styles.summaryLabel}>

Academic Period

</Text>

<Text style={styles.summaryValue}>

{data.period}

</Text>

</View>




<View style={styles.summaryBox}>

<Text style={styles.summaryLabel}>

Grade Class

</Text>

<Text style={styles.summaryValue}>

{data.grade_class}

</Text>

</View>




<View style={styles.summaryBox}>

<Text style={styles.summaryLabel}>

Students Reported

</Text>

<Text style={styles.summaryValue}>

{data.total_students}

</Text>

</View>




<View style={styles.summaryBox}>

<Text style={styles.summaryLabel}>

Total Complaints

</Text>

<Text style={styles.summaryValue}>

{data.total_complaints}

</Text>

</View>



</View>






{
data.students.map(
(student,index)=>(


<View

key={index}

style={styles.studentCard}

wrap={false}

>


<View style={styles.studentHeader}>


<Text style={styles.studentName}>

{student.student_name}

</Text>



<Text style={styles.countBadge}>

Total Complaints:
{" "}
{student.complaints.length}

</Text>


</View>





{
student.complaints.map(
(item,i)=>(


<View

key={i}

style={styles.complaintBox}

>


<Text style={styles.complaintTitle}>

{i+1}. {item.title}

</Text>



<Text style={styles.complaintText}>

{item.description}

</Text>



<Text style={styles.complaintMeta}>

Period:
{" "}
{item.period}

{"   |   "}

Date:
{" "}
{item.date?.split("T")[0]} {"   |   "}

Posted By:
{" "}
{item.poster_name}

</Text>



</View>


))

}



</View>


)

)

}





<View style={styles.footer}>


<Text style={styles.footerText}>

Generated Student Complaint Summary Report - Polu Integrated School Management System

</Text>


</View>




</Page>


</Document>


);


};


export default StudentComplainChartPDF;